window.$(function () {
  window.$(".table-sortable").sortable({
    axis: 'y',
    items: "> tr:not(.unsortable)",
    update: function () {
      let data = $(this).sortable('toArray', {attribute: 'data-id'});
      let url = $(this).data('url');

      axios.put(url, {order: data})
        .then(() => {
          window.toastr.success('Order successfully saved.');
        })
        .catch(() => {
          window.toastr.error('Server error. Please contact with administrator.');
        });
    },
  });
});
